import { render } from "./Book.vue?vue&type=template&id=834591e0"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"

import "./Book.vue?vue&type=style&index=0&id=834591e0&lang=css"

import exportComponent from "/home/jym/canvas_lms/lms/canvas/course_category_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__